import React from 'react';
import { connect } from 'react-redux';
import { getTranslatedString } from 'helpers/i18n';
import { featureEnabled } from 'helpers/ToggleBot';
import Form from 'components/ui/Form';
import Spacer from 'components/ui/Spacer';
import Row from 'components/ui/Row';
import Col from 'components/ui/Col';
import Select from 'components/ui/SelectField';
import styled from 'styled-components';
import { LegalNotice, NoticeTypes } from '../../../constants';
import { modes } from '../NoticeHelpers';

const FullWidthSelect = styled(Select)`
  width: 100%;
`;

const StyledColMb8 = styled(Col)`
  margin-bottom: 8px;
`;

const StyledTitle = styled.span`
  font-size: 18px;
  font-family: 'Circular-Bold';
`;

const TypeInput = ({ values, errors, touched, setFieldValue, legalNoticesEnabled }) => {
  const isTemplate = () => {
    return !!values.notice_template_id && values.notice_template_id !== 'none';
  };

  const handleChange = (type) => {
    setFieldValue('notice_type', type);
    setFieldValue('properties', []);
    setFieldValue('units', []);
    setFieldValue('floors', []);
    setFieldValue('risers', []);
    setFieldValue('mode', modes.SELECTING_PROPERTY);
  };

  const noticeTypes = () => {
    let types = NoticeTypes;
    if (!legalNoticesEnabled) {
      types = types.filter((t) => t.value !== LegalNotice);
    }

    return types;
  };

  if (isTemplate()) return null;

  return (
    <>
      <Spacer mb={1}>
        <Row gutter={16}>
          <StyledColMb8 span={24}>
            <StyledTitle>{getTranslatedString('landlordPortal.noticeForm.type')}</StyledTitle>
          </StyledColMb8>
          <Col span={24}>
            <Form.Item
              label={getTranslatedString('landlordPortal.noticeForm.selectType')}
              validateStatus={touched.notice_type && errors.notice_type ? 'error' : null}
              help={touched.notice_type && errors.notice_type}
            >
              <FullWidthSelect
                name="notice_type"
                value={values.notice_type}
                onChange={handleChange}
                placeholder="Select type..."
                size="large"
                error={touched.notice_type && errors.notice_type}
              >
                {noticeTypes().map((type) => (
                  <Select.Option value={type.value} key={type.value}>
                    {type.label}
                  </Select.Option>
                ))}
              </FullWidthSelect>
            </Form.Item>
          </Col>
        </Row>
      </Spacer>
    </>
  );
};

export default connect(
  (store) => ({
    legalNoticesEnabled:
      featureEnabled('legal_documents_as_notices') &&
      !!store.companyDetails.companyPreferences.enable_tenant_legal_notices,
  }),
  {}
)(TypeInput);
